"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppCore = void 0;
var JsonHandler_1 = require("./util/jsonloader/JsonHandler");
var Level_1 = require("./game/Level");
var Word_1 = require("./game/Word");
var Events_1 = require("./util/events/Events");
var ScreenChangeEvent_1 = require("./events/ScreenChangeEvent");
var AppCore = /** @class */ (function (_super) {
    __extends(AppCore, _super);
    function AppCore(_platformType) {
        var _this = _super.call(this) || this;
        _this._platformType = _platformType;
        _this._levels = [];
        _this._words = [];
        _this.loadedJsonCount = 0;
        AppCore.instance = _this;
        _this.loadJson();
        return _this;
    }
    AppCore.prototype.loadJson = function () {
        var levelsJson = new JsonHandler_1.JsonHandler("json/levels.json", this._platformType, this.onLevelJsonLoaded.bind(this));
        levelsJson.load();
        var wordsJson = new JsonHandler_1.JsonHandler("json/words.json", this._platformType, this.onWordsJsonLoaded.bind(this));
        wordsJson.load();
    };
    AppCore.prototype.onLevelJsonLoaded = function (json, hasError) {
        if (hasError === true) {
            // @TODO
            // Handle errors
            return;
        }
        this.parseLevels(json.levels);
        this.checkComplete();
    };
    AppCore.prototype.onWordsJsonLoaded = function (json, hasError) {
        if (hasError === true) {
            // @TODO
            // Handle errors
            return;
        }
        this.parseWords(json.words);
        this.checkComplete();
    };
    AppCore.prototype.checkComplete = function () {
        // @TODO - Bit wanky
        this.loadedJsonCount++;
        if (AppCore.JSON_COUNT == this.loadedJsonCount) {
            this.dispatchEvent(new ScreenChangeEvent_1.AppCoreReadyEvent(ScreenChangeEvent_1.AppCoreReadyEvent.APP_READY));
        }
    };
    AppCore.prototype.parseLevels = function (levels) {
        for (var i = 0; i < levels.length; i++) {
            this._levels.push(Level_1.Level.fromJson(levels[i]));
        }
    };
    AppCore.prototype.parseWords = function (words) {
        for (var i = 0; i < words.length; i++) {
            this._words.push(Word_1.Word.fromJson(words[i]));
        }
    };
    AppCore.prototype.getWordById = function (id) {
        for (var i = 0; i < this._words.length; i++) {
            if (id == this._words[i].id) {
                return this._words[i];
            }
        }
        return null;
    };
    Object.defineProperty(AppCore.prototype, "levels", {
        get: function () { return this._levels; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AppCore.prototype, "words", {
        get: function () { return this._words; },
        enumerable: false,
        configurable: true
    });
    AppCore.JSON_COUNT = 2;
    return AppCore;
}(Events_1.EventDispatcher));
exports.AppCore = AppCore;
